import { useTranslation } from "react-i18next";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function LanguageToggle({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.resolvedLanguage ?? i18n.language;
  const isChinese = activeLanguage.toLowerCase().startsWith("zh");

  return (
    <button
      type="button"
      onClick={() => {
        void i18n.changeLanguage(isChinese ? "en" : "zh");
      }}
      className={cn(buttonVariants({ variant: "ghost", size: "sm" }), className)}
      aria-label={t("layout.language")}
    >
      {isChinese ? "EN" : "中文"}
    </button>
  );
}
